









































import Vue from 'vue'

export default Vue.extend({
  props: {
    location: {
      type: Object,
    },
    company: {
      type: Object,
    },
    user: {
      type: Object,
    },
  },
  computed: {
    showWordpressOption() {
      try {
        if (
          this.company &&
          this.location &&
          this.company.stripeConnectId &&
          this.location.wordpressReseller &&
          this.location.wordpressReseller.location_enabled 
        ) {
          return true
        }
      } catch (err) {
        console.error(err)
      }
      return false
    },

    wpInstalled() {
    return this.location &&  this.location.wordpressReseller.wp_id
    },
  },
  methods: {
    gotoWordpressPitch() {
      this.$router.push({ name: 'wordpress_dashboard' })
    },
  },
})
